import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";

import { styles } from "../styles";
import { slideIn } from "../utils/motion";

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';

const Contact = () => {
    const formRef = useRef();
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        emailjs
            .send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                {
                    from_name: form.name,
                    to_name: "Peter Butora",
                    from_email: form.email,
                    to_email: "petik.butor@seznam.cz",
                    message: form.message,
                },
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )
            .then(
                () => {
                    setLoading(false);
                    alertify.success("Thank you. I will get back to you as soon as possible.");

                    setForm({
                        name: "",
                        email: "",
                        message: "",
                    });
                },
                (error) => {
                    setLoading(false);
                    console.error(error);

                    alertify.error('Ahh, something went wrong. Please try again.'); 
                }
            );
    };

    return (
        <motion.section id="contact">
            <div
                className={`xl:my-12 flex justify-center gap-10 overflow-hidden px-5`}
            >
                <motion.div
                    variants={slideIn("left", "tween", 0.2, 1)}
                    className='md:flex-[0.5] flex-1 bg-black-100 p-8 rounded-2xl'
                >
                    <p className={`${styles.sectionSubText} text-center`}>Get in touch</p>
                    <h3 className={`${styles.sectionHeadText} text-center`}>Contact.</h3>

                    <form
                        ref={formRef}
                        onSubmit={handleSubmit}
                        className='mt-12 flex flex-col gap-8'
                    >
                        <label className='flex flex-col'>
                            <span className='text-white font-medium mb-4'>Your Name</span>
                            <input
                                type='text'
                                name='name'
                                value={form.name}
                                onChange={handleChange}
                                placeholder="Your name"
                                className='bg-gray-100 py-4 px-6 placeholder:text-black text-black rounded-lg outline-none border-none font-medium'
                            />
                        </label>
                        <label className='flex flex-col'>
                            <span className='text-white font-medium mb-4'>Your email</span>
                            <input
                                type='email'
                                name='email'
                                value={form.email}
                                onChange={handleChange}
                                placeholder="Your email"
                                className='bg-gray-100 py-4 px-6 placeholder:text-black text-black rounded-lg outline-none border-none font-medium'
                            />
                        </label>
                        <label className='flex flex-col'>
                            <span className='text-white font-medium mb-4'>Your Message</span>
                            <textarea
                                rows={7}
                                name='message'
                                value={form.message}
                                onChange={handleChange}
                                placeholder='Your message'
                                className='bg-gray-100 py-4 px-6 placeholder:text-black text-black rounded-lg outline-none border-none font-medium'
                            />
                        </label>

                        <button
                            type='submit'
                            className='bg-tertiary py-3 px-8 rounded-xl outline-none text-white font-bold'
                        >
                            {loading ? "SENDING..." : "SEND"}
                        </button>
                    </form>
                </motion.div>
            </div>
        </motion.section>
    );
};

export default Contact;